import React, { useState } from 'react';

export default function PlotTrackTray({ tray, sequences, onPlace }) {
  const [targetByScene, setTargetByScene] = useState({});
  const [placingId, setPlacingId] = useState(null);
  const [error, setError] = useState(null);

  if (!tray || tray.length === 0) return null;

  const place = async (sceneId) => {
    const parentSectionId = targetByScene[sceneId] || sequences[0]?.id;
    if (!parentSectionId) {
      setError('Add a sequence before placing a scene on the line.');
      return;
    }
    setPlacingId(sceneId);
    setError(null);
    try {
      await onPlace({ sceneId, parentSectionId });
    } catch (err) {
      setError(err?.message || 'Could not place that scene.');
    } finally {
      setPlacingId(null);
    }
  };

  return (
    <section className="pt-tray" aria-label="Unplaced scenes">
      <header className="pt-tray__header">
        <h2>Unplaced scenes</h2>
        <p>These are not columns. Place them on a sequence to put them on the line.</p>
      </header>
      {error && <p className="pt-tray__error">{error}</p>}
      <ul className="pt-tray__list">
        {tray.map((scene) => (
          <li key={scene.scene_id} className="pt-tray__item">
            <span className="pt-tray__name">{scene.display_name || 'Untitled scene'}</span>
            <select
              aria-label={`Place ${scene.display_name || 'Untitled scene'} on`}
              value={targetByScene[scene.scene_id] || sequences[0]?.id || ''}
              onChange={(e) => setTargetByScene((prev) => ({
                ...prev,
                [scene.scene_id]: e.target.value,
              }))}
              disabled={sequences.length === 0}
            >
              {sequences.length === 0 && <option value="">No sequence yet</option>}
              {sequences.map((seq) => (
                <option key={seq.id} value={seq.id}>
                  {seq.display_name || 'Untitled sequence'}
                </option>
              ))}
            </select>
            <button
              type="button"
              onClick={() => place(scene.scene_id)}
              disabled={placingId === scene.scene_id || sequences.length === 0}
            >
              {placingId === scene.scene_id ? 'Placing…' : 'Place on the line'}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
